const alphaMixin = (hexCode, opacity = 1) => {
  return `rgba(${hexCode}, ${opacity})`;
};

const KatalTheme = {
  colors: {
    Athens: '#D5DBDB',
    Azure: '#F5F9FA',
    Bondi: '#00A4B4',
    BloodOrange: '#E02D00',
    Casper: '#AAB7B8',
    Crimson: '#CC0C39',
    Eastern: '#008296',
    Fiji: '#538000',
    JungleMist: '#B6D0D3',
    Lagoon: '#006878',
    Lake: '#E5F2F4',
    Lime: '#EDF2E5',
    Lemon: '#FFF5D1',
    Lush: '#FAEAEA',
    Mystic: '#7FC2BB',
    Nordic: '#002F36',
    Persimmon: '#FF8F00',
    Seattle: '#EBEEEF',
    Snow: '#FAFAFA',
    Submarine: '#879596',
    Tarpon: '#667575',
    White: '#FFFFFF',
    Zircon: '#E3ECED',
  },
  opacity: {
    high: 0.25,
    medium: 0.5,
    low: 0.75,
  },
  fontWeight: {
    light: 300,
    regular: 400,
    bold: 700,
  },
  fontSize: {
    xxxl: '2rem',
    xxl: '1.5rem',
    xl: '1.25rem',
    l: '1rem',
    m: '0.875rem',
    s: '0.83rem',
    xs: '0.75rem',
  },
  lineHeight: {
    xxxl: '2rem',
    xxl: '1.5rem',
    xl: '1.25rem',
    l: '1rem',
    m: '0.875rem',
    s: '0.75rem',
    xs: '0.5rem',
  },
  applyAlpha: alphaMixin,
};

export default KatalTheme;
